// extracted by mini-css-extract-plugin
module.exports = {"button__color":"errorContent_button__color__ccUl1"};